@if (loading()) {
<div class="flex flex-col justify-center items-center w-full h-64">
  <p>Loading hire history</p>
</div>
} @else if (error()) {
<div class="flex flex-col justify-center items-center w-full h-64">
  <p>Error loading hire history</p>
</div>
} @else {
@if (!hireHistory().length) {
<p>No hire history found</p>
} @else {
<table mat-table [dataSource]="hireHistory()">
  <tr mat-header-row *matHeaderRowDef="columns"></tr>
  <tr mat-row *matRowDef="let row; columns: columns"></tr>

  <ng-container matColumnDef="docket">
    <th mat-header-cell *matHeaderCellDef mat-sort-header="id">Contract</th>
    <td mat-cell *matCellDef="let element">
      <a [routerLink]="['docket', element.docket_id]">{{ element.docket_id }}
        @if (element.docket.account_reference) {
        ({{ element.docket.account_reference }})
        }
      </a>
    </td>
  </ng-container>
  <ng-container matColumnDef="customer">
    <th mat-header-cell *matHeaderCellDef>Customer</th>
    <td mat-cell *matCellDef="let element">
      <a [routerLink]="['/customer', element.docket.customer.id]">
        {{ element.docket.customer | customerName }}
      </a>
    </td>
  </ng-container>
  <ng-container matColumnDef="on_hire">
    <th mat-header-cell *matHeaderCellDef mat-sort-header="on_hire">On hire</th>
    <td mat-cell *matCellDef="let element">
      {{ element.on_hire | amDateFormat: dateFormat }}
    </td>
  </ng-container>
  <ng-container matColumnDef="off_hire">
    <th mat-header-cell *matHeaderCellDef mat-sort-header="off_hire">
      Off hire
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.off_hire | amDateFormat: dateFormat }}
    </td>
  </ng-container>
  <ng-container matColumnDef="charge">
    <th mat-header-cell *matHeaderCellDef mat-sort-header="status">Charge</th>
    <td mat-cell *matCellDef="let element">
      {{ element.charge | hlCurrency: null : 1 : false | async }}
    </td>
  </ng-container>
</table>
}
}